// extracted by mini-css-extract-plugin
export default {"title":"TargetRiskPoolModal_title__uBIPR","secondaryText":"TargetRiskPoolModal_secondaryText__m4kJW"};